import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  Customer,
  DropdownValue,
  QuestionnaireField,
  Status,
} from "../../master-data/master-data.model";
import { MasterDataService } from "../../master-data/master-data-service";
import { ControlType } from "../../forms/item/item.model";
import { FormBuilder, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-status-questionnaire-edit",
  templateUrl: "./status-questionnaire-edit.component.html",
  styleUrls: ["./status-questionnaire-edit.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatusQuestionnaireEditComponent {
  private masterData = inject(MasterDataService);
  private formBuilder = inject(FormBuilder);

  status: Status = null;
  customer: Customer = null;
  questionnaireFields: QuestionnaireField[];
  questionnaireRemoved: QuestionnaireField[] = [];
  questionnaireAdded: QuestionnaireField[] = [];
  ControlType = ControlType;
  createNewMode = false;
  dropdownValues: string[] = [];
  newFieldForm = this.formBuilder.group({
    tag: new FormControl<string | "">("", Validators.required),
    title: new FormControl<string | "">("", Validators.required),
    type: new FormControl<ControlType | null>(null, Validators.required),
    dropdownValue: new FormControl<string | "">(""),
    sort: new FormControl<number | 0>(0),
    required: new FormControl<boolean | false>(false),
  });

  selectedStatus($event: Status) {
    this.status = $event;
    this.masterData
      .getQuestionnaireFieldsForStatus(this.customer.uuid, this.status.uuid)
      .subscribe((value) => (this.questionnaireFields = value));
    this.questionnaireRemoved = [];
    this.questionnaireAdded = [];
  }

  onCustomerSelected($event: Customer) {
    // this.customerService.selectCustomer($event);
    this.customer = $event;
    this.status = null;
  }

  clearCustomer() {
    this.customer = null;
    this.status = null;
  }

  getOptionsString(question: QuestionnaireField) {
    let result = "";
    question.values.forEach((val) => (result = result + " " + val.value));
    return result;
  }

  removeField(question: QuestionnaireField) {
    const index = this.questionnaireFields.findIndex(
      (qst) => qst.uuid === question.uuid
    );
    this.questionnaireRemoved.push(this.questionnaireFields.at(index));
    this.questionnaireFields.splice(index, 1);
  }

  saveDropdownOption() {
    this.dropdownValues.push(this.newFieldForm.value.dropdownValue);
    this.newFieldForm.controls.dropdownValue.reset();
  }

  disableCreatingMode() {
    this.createNewMode = false;
    this.resetForm();
  }

  saveQuestion() {
    const newValue = new QuestionnaireField(
      this.newFieldForm.value.tag,
      this.newFieldForm.value.title,
      this.newFieldForm.value.type,
      this.dropdownValues.length > 0
        ? this.dropdownValues.map(this.mapToDropdownValue)
        : null,
      this.customer,
      this.status,
      this.newFieldForm.value.required,
      this.newFieldForm.value.sort
    );
    this.questionnaireFields.push(newValue);
    this.questionnaireAdded.push(newValue);
    this.resetForm();
  }

  private resetForm() {
    this.newFieldForm.reset();
    this.dropdownValues = [];
    this.createNewMode = false;
  }

  mapToDropdownValue(value: string) {
    return new DropdownValue(value, value);
  }

  saveQuestionnaire() {
    // console.log(this.questionnaireAdded);
    this.questionnaireRemoved.forEach((obj) =>
      this.masterData.deleteQuestionnaireField(obj.uuid)
    );
    this.questionnaireAdded.forEach((obj) =>
      this.masterData.saveQuestionnaireField(obj)
    );
    this.resetForm();
  }

  enableCreateMode() {
    this.createNewMode = true;
  }
}
